import React from 'react';

const IcCloseMenu = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.60116 4.39899C5.26922 4.06704 4.73104 4.06704 4.3991 4.39899C4.06716 4.73094 4.06716 5.26914 4.3991 5.60109L10.798 12.0002L4.39938 18.399C4.06744 18.731 4.06744 19.2692 4.39938 19.6011C4.73132 19.9331 5.2695 19.9331 5.60144 19.6011L12.0001 13.2023L18.3987 19.6011C18.7306 19.933 19.2688 19.933 19.6007 19.6011C19.9327 19.2691 19.9327 18.7309 19.6007 18.399L13.2021 12.0002L19.601 5.60114C19.9329 5.26919 19.9329 4.73099 19.601 4.39904C19.2691 4.06708 18.7309 4.06708 18.3989 4.39904L12.0001 10.7981L5.60116 4.39899Z'
                fill='#333438'
            />
        </svg>
    );
};

export default IcCloseMenu;
